import axios from '~/utils/axios';
import { HeadTransaction } from '~/types/HeadTransaction';
import { Amount } from '~/types';

interface ReferenceEntry {
  id: string;
  value: string;
}

export interface CreateOrUpdateConsentRequest {
  senderAccountId: string;
  recipientAccountId: string;
  amount: Amount;
  comment?: string;
  referenceId?: ReferenceEntry[];
}

export const createConsent = (request: CreateOrUpdateConsentRequest) => {
  const url = `/settlement/consent`;
  return axios.post<HeadTransaction>(url, request);
};

export const updateConsent = (consentId: string, request: CreateOrUpdateConsentRequest) => {
  const url = `/settlement/consent/${consentId}`;
  return axios.put<HeadTransaction>(url, request);
};

interface CreateTransactionProps {
  consentId: string;
}

export const createTransaction = ({ consentId }: CreateTransactionProps) => {
  const url = `/settlement`;
  return axios.post<HeadTransaction>(url, { consentId });
};
